import { Injectable } from '@angular/core';
import {HttpClientService} from "./http-client.service";
import {HttpParams} from "@angular/common/http";
import {parametros} from "../models/parametros";
import {WebSocketService} from "./web-socket.service";
import {switchMap} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class ParametrosService {

  constructor(private http: HttpClientService, private webSocketService: WebSocketService) { }

  public getByIdDispositivo(idDispositivo: string) {
    let params = new HttpParams().set("idDispositivo", idDispositivo);
    return this.http.getWithParams('/parametros/getbyiddispositivo', params);
  }

  public getByIdDispositivoAndTipo(idDispositivo: string, tipo: string) {
    let params = new HttpParams().set("idDispositivo", idDispositivo).set("tipo", tipo);
    return this.http.getWithParams('/parametros/getbyiddispositivoandtipo', params);
  }

  public loadFromGW(idDispositivo: string, tipo: string) {
    let body =
      {
        "idDispositivo": idDispositivo,
        "tipo": tipo
      };
    return this.http.postResponseJSON('/parametros/loadfromgw', body).pipe(
      switchMap((response: any) => this.webSocketService.waitForParametrosResponse(response.requestId))
    );
  }

  public setWithIdDispositivo(idProyecto: string, idDispositivo: string, tipo: string, parametros: parametros[]) {
    let body =
      {
        "idProyecto": idProyecto,
        "idDispositivo": idDispositivo,
        "tipo": tipo,
        "parametros": parametros
      }
    return this.http.postResponseJSON('/parametros/write', body).pipe(
      switchMap((response: any) => this.webSocketService.waitForParametrosResponse(response.requestId))
    );
  }

}
